import Vue from 'vue'
import ToastComponent from '../components/toast'
var timer=null;
export default {
    install:function (Vue) {
        const ToastConstructor = Vue.extend(ToastComponent);
        const instance = new ToastConstructor();
        instance.$mount(document.createElement('div'));
        document.body.appendChild(instance.$el);
        Vue.prototype.$toast = (msg, duration = 3000) => {
            clearTimeout(timer);
            instance.message = msg;
            instance.visible = true;
            timer=setTimeout(() => {
                instance.visible = false;
            }, duration);
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/service/toast.js